export default __webpack_public_path__ + "static/Team-machstatz-2900d0b0f2e55799bb13ab862b4f557c.jpg";